export default __webpack_public_path__ + "static/media/volume.850a08ba.svg";